var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.compiledTemplate)?_c(_vm.compiledTemplate.comp,_vm._b({tag:"component"},'component',_vm.compiledTemplate.props,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }